/* eslint-disable */
import { Message } from 'element-ui'
import { getData, addData, removeData } from '@/requests/admins'
import Api from '@/repository/index'
import { confirmWarning, handleErrorMessage } from '@/core/helpers/messageHelper'

const state = {
  data: [],
  users: [],
  logs: [],
  logs_filters: {
    type: null
  },
  types: [],
  isLoading: true,
  totalCount: 0,
  filters: {
    limit: 50,
    offset: 0,
    comment: '',
    start_date: null,
    end_date: null
  }
}
const getters = {
  getLogsParks (state) {
    const getUnique = [...new Set([...state.logs.map(x => x.park_id)])]
    return getUnique
  },
  getLogsByFiter (state) {
    const { type, park } = state.logs_filters
    if (type) {
      return state.logs.filter(x => x.description === type)
    }
    if (park) {
      return state.logs.filter(x => x.park_id === park)
    }
    return state.logs
  }
}
const mutations = {
  SET_TOTAL_COUNT: (state, total) => {
    state.totalCount = total
  },
  SET_FILTERS: (state, filters) => {
    state.filters = filters
  },
  SET: (state, data) => {
    state.data = data
  },
  SET_USERS: (state, data) => {
    state.users = data
  },
  TOOGLE_LOADING: (state, data) => {
    state.isLoading = data
  },
  REMOVE_USER_BY_ID: (state, id) => {
    state.users = [...state.users.filter(user => user.id !== id)]
  },
  REMOVE_PARK_IN_USER_BY_ID: (state, { userId, parkId }) => {
    const userIndex = state.users.findIndex(x => x.id === userId)
    const user = state.users[userIndex]
    state.users.splice(userIndex, 1, {
      ...user,
      parks: user.parks.filter(park => park.id !== parkId)
    })
  },
  REMOVE_ROLE_IN_USER_BY_ID: (state, { userId, roleId }) => {
    const userIndex = state.users.findIndex(x => x.id === userId)
    const user = state.users[userIndex]
    state.users.splice(userIndex, 1, {
      ...user,
      role: user.role.filter(role => role.id !== roleId)
    })
  },
  ADD_ROLE_TO_USER: (state, data) => {
    const userIndex = state.users.findIndex(x => x.id === data.userId)
    const user = state.users[userIndex]
    state.users.splice(userIndex, 1, {
      ...user,
      role: { ...user.role, data }
    })
  },
  REMOVE: (state, id) => {
    state.data = state.data.filter(cur => cur.id !== id)
  },
  ADD: (state, data) => {
    state.users.push(data)
  },
  UPDATE_USER: (state, data) => {
    const userIndex = state.users.findIndex(x => x.id === data.id)
    const user = state.users[userIndex]
    state.users.splice(userIndex, 1, {
      ...user,
      ...data
    })
  },
  SET_LOGS: (state, logs) => {
    state.logs = logs
  },

  SET_LOGS_FILTERS: (state, logs) => {
    state.logs_filters = logs
  },
  START_LOGS_LOADING: (state) => {
    state.logsLoading = true
  },
  STOP_LOGS_LOADING: (state) => {
    state.logsLoading = false
  },
  SET_LOG_TYPES: (state, types) => {
    state.types = types
  }
}

const actions = {
  setLogFilter ({ commit }, data) {
    commit('SET_LOGS_FILTERS', data)
  },
  setPaginationFilters ({ commit }, filters) {
    commit('SET_FILTERS', filters)
  },
  async fetchUsersByPark ({ commit, state, rootGetters }) {
    try {
      commit('TOOGLE_LOADING', true)
      const response = await Api.users.getUsersByParkId(rootGetters['userStore/getActualPark']().id)
      commit('SET_USERS', response || [])
      commit('TOOGLE_LOADING', false)
      return response
    } catch (err) {
      commit('TOOGLE_LOADING', false)
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },
  async setRoleToUser ({ commit, dispatch }, data) {
    try {
      await Api.users.setRoleToUser(data)
      await dispatch('fetchUsersByPark')
      Message({
        message: 'Успешно',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      commit('TOOGLE_LOADING', false)
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },

  async unbindParkForUser ({ commit, dispatch, rootGetters }, { userId }) {
    try {
      const parkId = rootGetters['userStore/getActualPark']().id
      await Api.users.unbindParkForUser({
        parkId,
        userId
      })
      // commit('REMOVE_USER_BY_ID', userId)
      await dispatch('fetchUsersByPark')
      Message({
        message: 'Парк был отвязан от пользователя!',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },

  async deleteUser ({ dispatch }, userId) {
    try {
      await Api.users.deleteUser(userId)

      await dispatch('fetchUsersByPark')

      Message({
        message: 'Парк был отвязан от пользователя!',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      handleErrorMessage(err, 'Не удалось уволить пользователя')
    }
  },

  async removeRoleInUser ({ commit, dispatch, rootGetters }, { userId, roleId }) {
    try {
      // const parkId = rootGetters['user/getActualPark']?.id
      const response = await Api.users.removeRoleInUser({
        userId, roleId
      })
      await dispatch('fetchUsersByPark')
      Message({
        message: 'Роль была отвязана от пользователя!',
        type: 'success',
        duration: 5 * 1000
      })
      return response
    } catch (err) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },
  async updateUser ({ commit, dispatch, rootGetters }, data) {
    try {
      const response = await Api.users.updateUser(data)
      await dispatch('fetchUsersByPark')
      Message({
        message: 'Информация об администраторе была изменена',
        type: 'success',
        duration: 5 * 1000
      })
      return response
    } catch (err) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },

  async updateUserPassword(_, data) {
    await Api.users.updateUserPassword(data)
  },

  async fetchLogs ({ state, commit }, queryDto) {
    try {
      commit('START_LOGS_LOADING')

      const response = await Api.event.getEvents({ ...state.filters })
      commit('SET_TOTAL_COUNT', response.total - 1)

      commit('SET_LOGS', response.events ?? [])
      commit('SET_LOG_TYPES', response.types ?? [])
      commit('STOP_LOGS_LOADING')
    } catch (e) {
      commit('STOP_LOGS_LOADING')
      return Promise.reject(e)
    }
  },

  fetch ({ commit }) {
    return getData()
      .then(data => {
        commit('SET', data)
        return data
      })
      .catch((error) => {
        return error
      })
  },

  remove ({ commit }, id) {
    return new Promise((resolve, reject) => {
      removeData(id).then(() => {
        commit('REMOVE', id)
        Message({
          message: 'Администратор был удален',
          type: 'success',
          duration: 5 * 1000
        })
        resolve(id)
        return id
      }).catch(error => {
        Message({
          message: 'Ошибка',
          type: 'error',
          duration: 5 * 1000
        })
        reject(error)
      })
    })
  },
  async createUser ({ dispatch, state, rootGetters }, data) {
    try {
      const parkId = rootGetters['userStore/getActualPark']().id
      const response = await Api.users.createUser({ ...data, parkId })
      await dispatch('fetchUsersByPark')
      Message({
        message: 'Администратор был добавлен',
        type: 'success',
        duration: 5 * 1000
      })
      return response
    } catch (err) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  },
  add ({ commit }, data) {
    return new Promise((resolve, reject) => {
      addData(data).then(res => {
        commit('ADD', res)
        Message({
          message: 'Администратор был добавлен',
          type: 'success',
          duration: 5 * 1000
        })
        resolve(data)
      }).catch(error => {
        Message({
          message: 'Ошибка',
          type: 'error',
          duration: 5 * 1000
        })
        reject(error)
      })
    })
  }
  // change ({ commit }, { id, data }) {
  //   return new Promise((resolve, reject) => {
  //     changeData(id, data).then(res => {
  //       commit('CHANGE', res)
  //       Message({
  //         message: 'Информация об администраторе была изменена',
  //         type: 'success',
  //         duration: 5 * 1000
  //       })
  //       resolve(data)
  //     }).catch(error => {
  //       Message({
  //         message: 'Ошибка',
  //         type: 'error',
  //         duration: 5 * 1000
  //       })
  //       reject(error)
  //     })
  //   })
  // }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
